import { apiRequest } from "@/lib/api-request";

// Skript-PDF-Zusammenfassung fuers Pitch-Formular. Reiner Proxy-Aufruf zur BFF
// (/ai/tobis/summarize-script -> agent-service, TobisScriptSummaryController) -
// wie tobis-lab-pitch-compare.ts und tobis-lab-resolve-persons.ts laeuft das
// ueber den Assistenten-Transport (agent-proxy, ADR-0018), nicht ueber
// tobis-api/* (lib/tobis.ts). Der PDF-Volltext geht nur in diesen einen
// Request, Spark speichert nur die zurueckgegebene Zusammenfassung.

export async function summarizeScript(fileName: string, base64Content: string): Promise<string> {
  const { response } = await apiRequest("ai/tobis/summarize-script", {
    method: "POST",
    csrf: true,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ fileName, content: base64Content }),
  });
  if (!response.ok) throw new Error(`summarize-script → ${response.status}`);
  const { summary } = (await response.json()) as { summary: string };
  return summary;
}

/** Liest eine Datei als reinen Base64-String (ohne den `data:...;base64,`-Praefix), fuer den
 *  JSON-Body oben - dasselbe Base64-inline-Muster wie genesis' Binary-Scalar-Mutations. */
export function readFileAsBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      const commaIndex = result.indexOf(",");
      resolve(commaIndex >= 0 ? result.slice(commaIndex + 1) : result);
    };
    reader.onerror = () => reject(reader.error ?? new Error("FileReader failed"));
    reader.readAsDataURL(file);
  });
}
